var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 57291",
    viewBox: "0 0 24.135 18.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    "data-name": "Group 15284",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.256 6.761.523-.634a1.835 1.835 0 0 0 1.2.494c.362 0 .58-.145.58-.4 0-.227-.138-.343-.81-.517-.81-.209-1.333-.436-1.333-1.255a1.263 1.263 0 0 1 1.41-1.221 2.313 2.313 0 0 1 1.494.517l-.46.674a1.875 1.875 0 0 0-1.046-.4c-.339 0-.517.157-.517.366 0 .267.172.354.868.535.816.215 1.276.512 1.276 1.232 0 .808-.609 1.261-1.477 1.261a2.544 2.544 0 0 1-1.708-.652Z",
    "data-name": "Path 18558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 4.111H7.836v-.825h3.334v.825H9.946v3.243h-.885Z",
    "data-name": "Path 18559"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.497 5.32a2.138 2.138 0 1 1 2.132 2.1 2.092 2.092 0 0 1-2.132-2.1Zm3.351 0a1.23 1.23 0 0 0-1.218-1.279 1.214 1.214 0 0 0-1.207 1.279 1.23 1.23 0 0 0 1.219 1.279 1.214 1.214 0 0 0 1.206-1.279Z",
    "data-name": "Path 18560"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.56 3.286h1.839a1.593 1.593 0 0 1 1.173.413 1.294 1.294 0 0 1 .345.941 1.262 1.262 0 0 1-.862 1.261l.983 1.453h-1.034l-.874-1.3h-.686v1.3h-.885Zm1.782 1.976c.431 0 .678-.232.678-.587 0-.384-.264-.581-.7-.581h-.876v1.168Z",
    "data-name": "Path 18561"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.706 5.75 20.16 3.286h1.034l.96 1.633.977-1.633h1.006l-1.546 2.447v1.621h-.885Z",
    "data-name": "Path 18562"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15285",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1aa9b4",
    d: "M1.584 2.813H0V1.592h1.584V-.001h1.243v1.593h1.584v1.221H2.827v1.593H1.584Z",
    "data-name": "Path 18565"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1aa9b4",
    d: "M4.248 8.799H6.43l2.419 3.934 2.419-3.934h2.18v9.3h-2.011v-6.073l-2.589 3.973h-.053l-2.563-3.934v6.033H4.248Z",
    "data-name": "Path 19285"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1aa9b4",
    d: "M15.657 8.799h3.588a4.657 4.657 0 1 1 0 9.3h-3.588Zm3.588 7.455a2.804 2.804 0 0 0 0-5.608h-1.567v5.608Z",
    "data-name": "Path 19286"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.cdc7d5af83eff8df961d599f908751c6.svg";
export { ForwardRef as ReactComponent };